/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmployeeDataSearchFields {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMPLOYEE_ID = 'employeeId',
    JOB_TITLE = 'jobTitle',
}
